class FnbReservations {}

export default FnbReservations;
